import { useMutation, useQueryClient } from 'react-query';
import { supabase } from '../lib/supabase';

export function useSupabaseMutation(table: string) {
  const queryClient = useQueryClient();

  return useMutation(
    async (data: any) => {
      if (!table) {
        throw new Error('Table name is required');
      }

      const { id, cpf, ...cleanData } = data;
      
      try {
        const { data: { user }, error: authError } = await supabase.auth.getUser();
        if (authError || !user) {
          throw new Error('User must be authenticated');
        }

        const dataWithUser = {
          ...cleanData,
          cpf,
          user_id: user.id
        };

        // For customers table, check if we're updating an existing record by ID
        if (table === 'customers' && id) {
          const { data: result, error } = await supabase
            .from(table)
            .update(dataWithUser)
            .eq('id', id)
            .select()
            .single();

          if (error) throw error;
          return result;
        } else {
          // Always insert new record if no ID provided
          const { data: result, error } = await supabase
            .from(table)
            .insert(dataWithUser)
            .select()
            .single();
          
          if (error) throw error;
          return result;
        }

      } catch (error) {
        console.error(`[${table}] Operation error:`, error);
        throw error;
      }
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(table);
      }
    }
  );
}